'use client';

import { createPortal } from 'react-dom';
import { useIsClient } from '@/hooks';

const Portal = ({ children }: { children: React.ReactNode }) => {
  const isClient = useIsClient();

  if (!isClient) {
    return null;
  }

  const target = document.querySelector<HTMLElement>('#modal-root');
  return target ? createPortal(children, target) : null;
};

export default Portal;
